export default "__VITE_PUBLIC_ASSET__3cb9ed4f__"